webpackJsonp([42],{

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Container__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Container__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Compete',
  components: {
    Container: __WEBPACK_IMPORTED_MODULE_4__components_common_Container___default.a
  },
  data: function data() {
    return {
      palaceholder: 'http://api.shsgzgzjxyjh.cn/system/images/attachments/000/000/167/original/u_776200233_317664553_fm_200_gp_0.jpg?1546403692',
      competes: [],
      notifications: [],
      carousels: [],
      page: 1,
      notePage: 1,
      loading: true
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchTodoCount']), {
    showDetail: function showDetail(id, type) {
      this.$router.push('/competes/' + id + '?type=' + type);
    },
    getMoreNotification: function getMoreNotification() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var notification;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.notePage += 1;
                _context.prev = 1;
                _context.next = 4;
                return _this.$apis.notification.getNotifications('compete', _this.notePage, 9);

              case 4:
                notification = _context.sent;

                _this.notifications = _this.notifications.concat(notification.data.notifications);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                _this.$message.warning('获取通知信息失败 ！');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    getMoreCompete: function getMoreCompete() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.page += 1;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$apis.userCompete.getHistoryCompetesList(_this2.page, 8);

              case 4:
                _ref = _context2.sent;
                data = _ref.data;

                if (data) {
                  _this2.competes = _this2.competes.concat(data);
                } else {
                  _this2.$message.info('没有更多数据 ！');
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                _this2.$message.warning('获取比赛信息失败 ！');

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 9]]);
      }))();
    },
    fetchData: function fetchData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, data, carousels;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this3.$apis.userCompete.getHistoryCompetesList(_this3.page, 8);

              case 3:
                _ref2 = _context3.sent;
                data = _ref2.data;

                _this3.competes = data;
                _context3.next = 8;
                return _this3.$apis.carousel.getCarousel();

              case 8:
                carousels = _context3.sent;

                _this3.carousels = carousels.data;
                _this3.loading = false;
                _context3.next = 17;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](0);

                _this3.$message.warning('获取信息失败 ！');
                _this3.loading = false;

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 13]]);
      }))();
    }
  })
});

/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(587)(true);
// imports


// module
exports.push([module.i, ".main-container[data-v-b0d0fb96]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.container[data-v-b0d0fb96]{width:100%;max-width:1170px}.bread[data-v-b0d0fb96]{margin:20px 0}.carousel .el-carousel__item[data-v-b0d0fb96]{border-radius:8px;font-size:1.5em;text-align:center;line-height:100px}.carousel .el-carousel__item img[data-v-b0d0fb96]{width:100%;height:100%;-webkit-filter:saturate(.8)}.carousel .el-carousel__item .background[data-v-b0d0fb96]{text-align:center;width:100%;position:absolute;top:80px;left:0}.carousel .el-carousel__item .background .el-button[data-v-b0d0fb96]{border-radius:36px;padding:10px 35px}.carousel .el-carousel__item[data-v-b0d0fb96]:nth-child(2n){background-color:#99a9bf}.carousel .el-carousel__item[data-v-b0d0fb96]:nth-child(odd){background-color:#d3dce6}.competes-content .container-item[data-v-b0d0fb96]{margin-top:20px}.competes-content .container-item .topics-el-row[data-v-b0d0fb96]{padding:10px 10px 20px 20px;border:1px;border-bottom-left-radius:8px;border-bottom-right-radius:8px;margin:0;background:#fff}.competes-content .container-item .topics-el-row .topics-el-col[data-v-b0d0fb96]{min-height:265px;padding:15px 15px 0 0;border-radius:0}.competes-content .container-item .topics-el-row .topics-el-col[data-v-b0d0fb96]:nth-child(4n){border-radius:0;border-right:0}.img-content-first[data-v-b0d0fb96]{position:relative;height:250px}.img-content-first img[data-v-b0d0fb96]{position:absolute;left:0;top:0;width:100%;height:100%;-webkit-filter:saturate(.8)}.img-content-first .title[data-v-b0d0fb96]{font-size:1.35em;padding-right:80px;position:absolute;color:#fff;-webkit-filter:drop-shadow(5px 5px 5px #333);left:80px;top:90px;z-index:99}.img-content img[data-v-b0d0fb96]{-webkit-filter:grayscale(.8);height:140px;width:100%;padding-bottom:5px}.img-content[data-v-b0d0fb96],.topics-news[data-v-b0d0fb96]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.img-content span[data-v-b0d0fb96],.topics-news span[data-v-b0d0fb96]{font-size:12px;color:rgba(0,0,0,.6);padding-top:5px}.img-content .comp-time[data-v-b0d0fb96],.topics-news .comp-time[data-v-b0d0fb96]{color:rgba(0,0,0,.3)}.img-content .title[data-v-b0d0fb96],.img-content .topics-news-title[data-v-b0d0fb96],.topics-news .title[data-v-b0d0fb96],.topics-news .topics-news-title[data-v-b0d0fb96]{padding:8px 0;font-size:14px;color:#284050}.topics-news-content[data-v-b0d0fb96]{padding:14px 8px}.topics-news-content .empty[data-v-b0d0fb96]{text-align:center}.topics-news-content .empty img[data-v-b0d0fb96]{height:120px}.topics-news-content .topics-news[data-v-b0d0fb96]{border-bottom:1px solid #d6dbe2;padding-bottom:15px;margin-bottom:8px}.topics-news-content .topics-news[data-v-b0d0fb96]:last-child{border:0}h2[data-v-b0d0fb96]{font-weight:400;color:#fff;text-shadow:0 0 20px #7fa5a4}ul[data-v-b0d0fb96]{list-style-type:none;padding:0}li[data-v-b0d0fb96]{display:inline-block;margin:0 10px}a[data-v-b0d0fb96]{color:#42b983}.desc[data-v-b0d0fb96]{width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", "", {"version":3,"sources":["/Users/mushu/code/tallty/web/edu-system/src/components/User/Compete/Competes.vue"],"names":[],"mappings":"AACA,iCACE,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,kBAAoB,CACzB,AACD,4BACE,WAAY,AACZ,gBAAkB,CACnB,AACD,wBACE,aAAiB,CAClB,AACD,8CACE,kBAAmB,AACnB,gBAAiB,AACjB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,kDACE,WAAY,AACZ,YAAa,AACb,2BAA8B,CAC/B,AACD,0DACE,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,MAAQ,CACT,AACD,qEACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,4DACE,wBAA0B,CAC3B,AACD,6DACE,wBAA0B,CAC3B,AACD,mDACE,eAAiB,CAClB,AACD,kEACE,4BAA6B,AAC7B,WAAY,AACZ,8BAA+B,AAC/B,+BAAgC,AAChC,SAAU,AACV,eAAiB,CAClB,AACD,iFACE,iBAAkB,AAClB,sBAAuB,AACvB,eAAiB,CAClB,AACD,+FACE,gBAAiB,AACjB,cAAgB,CACjB,AACD,oCACE,kBAAmB,AACnB,YAAc,CACf,AACD,wCACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,2BAA8B,CAC/B,AACD,2CACE,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,WAAY,AACZ,6CAA8C,AAC9C,UAAW,AACX,SAAU,AACV,UAAY,CACb,AACD,kCACE,6BAA+B,AAC/B,aAAc,AACd,WAAY,AACZ,kBAAoB,CACrB,AACD,4DAEE,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,qBAAuB,CAC5B,AACD,sEAEE,eAAgB,AAChB,qBAAuB,AACvB,eAAiB,CAClB,AACD,kFAEE,oBAAuB,CACxB,AACD,4KAIE,cAAe,AACf,eAAgB,AAChB,aAAe,CAChB,AACD,sCACE,gBAAkB,CACnB,AACD,6CACE,iBAAmB,CACpB,AACD,iDACE,YAAc,CACf,AACD,mDACE,gCAAiC,AACjC,oBAAqB,AACrB,iBAAmB,CACpB,AACD,8DACE,QAAU,CACX,AACD,oBACE,gBAAoB,AACpB,WAAY,AACZ,4BAA8B,CAC/B,AACD,oBACE,qBAAsB,AACtB,SAAW,CACZ,AACD,oBACE,qBAAsB,AACtB,aAAe,CAChB,AACD,mBACE,aAAe,CAChB,AACD,uBACE,WAAY,AACZ,gBAAiB,AACjB,mBAAoB,AACpB,sBAAwB,CACzB","file":"Competes.vue","sourcesContent":["\n.main-container[data-v-b0d0fb96] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.container[data-v-b0d0fb96] {\n  width: 100%;\n  max-width: 1170px;\n}\n.bread[data-v-b0d0fb96] {\n  margin: 20px 0px;\n}\n.carousel .el-carousel__item[data-v-b0d0fb96] {\n  border-radius: 8px;\n  font-size: 1.5em;\n  text-align: center;\n  line-height: 100px;\n}\n.carousel .el-carousel__item img[data-v-b0d0fb96] {\n  width: 100%;\n  height: 100%;\n  -webkit-filter: saturate(0.8);\n}\n.carousel .el-carousel__item .background[data-v-b0d0fb96] {\n  text-align: center;\n  width: 100%;\n  position: absolute;\n  top: 80px;\n  left: 0;\n}\n.carousel .el-carousel__item .background .el-button[data-v-b0d0fb96] {\n  border-radius: 36px;\n  padding: 10px 35px;\n}\n.carousel .el-carousel__item[data-v-b0d0fb96]:nth-child(2n) {\n  background-color: #99a9bf;\n}\n.carousel .el-carousel__item[data-v-b0d0fb96]:nth-child(2n+1) {\n  background-color: #d3dce6;\n}\n.competes-content .container-item[data-v-b0d0fb96] {\n  margin-top: 20px;\n}\n.competes-content .container-item .topics-el-row[data-v-b0d0fb96] {\n  padding: 10px 10px 20px 20px;\n  border: 1px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  margin: 0;\n  background: #fff;\n}\n.competes-content .container-item .topics-el-row .topics-el-col[data-v-b0d0fb96] {\n  min-height: 265px;\n  padding: 15px 15px 0 0;\n  border-radius: 0;\n}\n.competes-content .container-item .topics-el-row .topics-el-col[data-v-b0d0fb96]:nth-child(4n) {\n  border-radius: 0;\n  border-right: 0;\n}\n.img-content-first[data-v-b0d0fb96] {\n  position: relative;\n  height: 250px;\n}\n.img-content-first img[data-v-b0d0fb96] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-filter: saturate(0.8);\n}\n.img-content-first .title[data-v-b0d0fb96] {\n  font-size: 1.35em;\n  padding-right: 80px;\n  position: absolute;\n  color: #fff;\n  -webkit-filter: drop-shadow(5px 5px 5px #333);\n  left: 80px;\n  top: 90px;\n  z-index: 99;\n}\n.img-content img[data-v-b0d0fb96] {\n  -webkit-filter: grayscale(0.8);\n  height: 140px;\n  width: 100%;\n  padding-bottom: 5px;\n}\n.img-content[data-v-b0d0fb96],\n.topics-news[data-v-b0d0fb96] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.img-content span[data-v-b0d0fb96],\n.topics-news span[data-v-b0d0fb96] {\n  font-size: 12px;\n  color: rgba(0,0,0,0.6);\n  padding-top: 5px;\n}\n.img-content .comp-time[data-v-b0d0fb96],\n.topics-news .comp-time[data-v-b0d0fb96] {\n  color: rgba(0,0,0,0.3);\n}\n.img-content .title[data-v-b0d0fb96],\n.topics-news .title[data-v-b0d0fb96],\n.img-content .topics-news-title[data-v-b0d0fb96],\n.topics-news .topics-news-title[data-v-b0d0fb96] {\n  padding: 8px 0;\n  font-size: 14px;\n  color: #284050;\n}\n.topics-news-content[data-v-b0d0fb96] {\n  padding: 14px 8px;\n}\n.topics-news-content .empty[data-v-b0d0fb96] {\n  text-align: center;\n}\n.topics-news-content .empty img[data-v-b0d0fb96] {\n  height: 120px;\n}\n.topics-news-content .topics-news[data-v-b0d0fb96] {\n  border-bottom: 1px solid #d6dbe2;\n  padding-bottom: 15px;\n  margin-bottom: 8px;\n}\n.topics-news-content .topics-news[data-v-b0d0fb96]:last-child {\n  border: 0;\n}\nh2[data-v-b0d0fb96] {\n  font-weight: normal;\n  color: #fff;\n  text-shadow: 0 0 20px #7fa5a4;\n}\nul[data-v-b0d0fb96] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-b0d0fb96] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-b0d0fb96] {\n  color: #42b983;\n}\n.desc[data-v-b0d0fb96] {\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1882:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1422);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(588)("6d1ba341", content, true, {});

/***/ }),

/***/ 2086:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bread"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("研究会")]), _c('el-breadcrumb-item', [_vm._v("比赛平台")])], 1)], 1), _c('div', {
    staticClass: "carousel"
  }, [(_vm.carousels.length > 0) ? _c('el-carousel', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "interval": 5000,
      "height": "460px",
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }, _vm._l((_vm.carousels), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [(item.background) ? _c('img', {
      attrs: {
        "src": item.background,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.palaceholder
      }
    }), _c('div', {
      staticClass: "background"
    }, [_c('h2', [_c('strong', [_vm._v(_vm._s(item.title))])]), _c('el-button', {
      staticClass: "todoBtn",
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail(item.id, 'compete')
        }
      }
    }, [_vm._v("新闻动态")])], 1)])
  }), 1) : _vm._e(), _c('el-row', {
    staticClass: "competes-content",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-row', {
    staticClass: "competes-content",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "xs": 24,
      "sm": 24,
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }, [_c('Container', {
    staticClass: "container-item",
    attrs: {
      "showMore": _vm.competes.length >= 6,
      "title": "往届比赛",
      "footer": "更多比赛"
    },
    on: {
      "getMore": _vm.getMoreCompete
    }
  }, [(_vm.competes.length != 0) ? _c('el-row', {
    staticClass: "topics-el-row"
  }, _vm._l((_vm.competes), function(item, index) {
    return _c('el-col', {
      key: index,
      staticClass: "topics-el-col",
      attrs: {
        "xs": 24,
        "sm": 6
      }
    }, [_c('div', {
      staticClass: "grid-content img-content",
      on: {
        "click": function($event) {
          return _vm.showDetail(item.id, 'compete')
        }
      }
    }, [(item.background) ? _c('img', {
      attrs: {
        "src": item.background,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.palaceholder
      }
    }), _c('div', {
      staticClass: "title signle-line"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc))]), _c('div', {
      staticClass: "comp-time"
    }, [_vm._v(_vm._s(_vm.$utils.dateTimeString(item.created_at)))])])])
  }), 1) : _c('div', {
    staticClass: "topics-news-content"
  }, [_c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": "/static/empty.svg",
      "alt": ""
    }
  }), _c('p', [_vm._v("暂无比赛")])])])], 1)], 1)], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1882)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1143),
  /* template */
  __webpack_require__(2086),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b0d0fb96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(725)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(727),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-80faf2e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Container',
  props: {
    showMore: {
      type: Boolean,
      default: false
    },
    showH: {
      type: String,
      default: 'true'
    },
    minH: {
      type: String,
      default: '400px'
    },
    titleCenter: {
      type: Boolean,
      default: false
    },
    titleBg: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '容器标题'
    },
    footer: {
      type: String,
      default: '查看更多'
    }
  },
  methods: {
    getMore: function getMore() {
      this.$emit('getMore');
    }
  }
});

/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(587)(true);
// imports


// module
exports.push([module.i, ".container-page[data-v-80faf2e0]{border:1px solid #e3e3e3;border-radius:8px}.container-page .content[data-v-80faf2e0]{width:100%;border:1px;border-bottom-left-radius:8px;border-bottom-right-radius:8px;background:#fff;border-top:1px solid #e3e3e3}.container-page .title-center[data-v-80faf2e0],.container-page .title[data-v-80faf2e0]{border:1px;border-top-left-radius:8px;border-top-right-radius:8px;background:#f7f7f7;width:100%;display:-ms-flexbox;display:flex;min-height:50px;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center}.container-page .title-center .img[data-v-80faf2e0],.container-page .title .img[data-v-80faf2e0]{padding:0 20px 20px}.container-page .title-center label[data-v-80faf2e0],.container-page .title label[data-v-80faf2e0]{height:50px;line-height:50px;display:inline-block}.container-page .footer[data-v-80faf2e0]{width:100%;border-radius:0}.container-page .title label[data-v-80faf2e0]{padding-left:20px}.container-page .footer[data-v-80faf2e0],.container-page .title-center[data-v-80faf2e0]{text-align:center}.container-page .footer i[data-v-80faf2e0]{padding-left:4px}", "", {"version":3,"sources":["/Users/mushu/code/tallty/web/edu-system/src/components/common/Container.vue"],"names":[],"mappings":"AACA,iCACE,yBAA0B,AAC1B,iBAAmB,CACpB,AACD,0CACE,WAAY,AACZ,WAAY,AACZ,8BAA+B,AAC/B,+BAAgC,AAChC,gBAAiB,AACjB,4BAA8B,CAC/B,AACD,uFAEE,WAAY,AACZ,2BAA4B,AAC5B,4BAA6B,AAC7B,mBAAoB,AACpB,WAAY,AACZ,oBAAqB,AACrB,aAAc,AACd,gBAAiB,AACjB,0BAA2B,AACvB,sBAAuB,AAC3B,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,iGAEE,mBAA0B,CAC3B,AACD,mGAEE,YAAa,AACb,iBAAkB,AAClB,oBAAsB,CACvB,AACD,yCACE,WAAY,AACZ,eAAiB,CAClB,AACD,8CACE,iBAAmB,CACpB,AAID,wFACE,iBAAmB,CACpB,AACD,2CACE,gBAAkB,CACnB","file":"Container.vue","sourcesContent":["\n.container-page[data-v-80faf2e0] {\n  border: 1px solid #e3e3e3;\n  border-radius: 8px;\n}\n.container-page .content[data-v-80faf2e0] {\n  width: 100%;\n  border: 1px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  background: #fff;\n  border-top: 1px solid #e3e3e3;\n}\n.container-page .title[data-v-80faf2e0],\n.container-page .title-center[data-v-80faf2e0] {\n  border: 1px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  background: #f7f7f7;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 50px;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.container-page .title .img[data-v-80faf2e0],\n.container-page .title-center .img[data-v-80faf2e0] {\n  padding: 0 20px 20px 20px;\n}\n.container-page .title label[data-v-80faf2e0],\n.container-page .title-center label[data-v-80faf2e0] {\n  height: 50px;\n  line-height: 50px;\n  display: inline-block;\n}\n.container-page .footer[data-v-80faf2e0] {\n  width: 100%;\n  border-radius: 0;\n}\n.container-page .title label[data-v-80faf2e0] {\n  padding-left: 20px;\n}\n.container-page .title-center[data-v-80faf2e0] {\n  text-align: center;\n}\n.container-page .footer[data-v-80faf2e0] {\n  text-align: center;\n}\n.container-page .footer i[data-v-80faf2e0] {\n  padding-left: 4px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(724);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(588)("4ec36cea", content, true, {});

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notification_title_bg.b1b2520.png";

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-page"
  }, [(_vm.showH !== 'false') ? _c('div', {
    staticClass: "title-content"
  }, [(_vm.titleCenter) ? _c('div', {
    staticClass: "title-center"
  }, [_vm._v(_vm._s(_vm.title))]) : _c('div', {
    staticClass: "title"
  }, [_c('label', [_vm._v(_vm._s(_vm.title))]), (_vm.titleBg) ? _c('img', {
    staticClass: "img",
    attrs: {
      "src": __webpack_require__(726),
      "alt": ""
    }
  }) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2), (_vm.showMore) ? _c('el-button', {
    staticClass: "footer todoBtn",
    on: {
      "click": _vm.getMore
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.footer))]), _c('i', {
    staticClass: "el-icon-arrow-down"
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/42.bf154a6f10b7295e6e2c.js